import classNames from "classnames";
import React, { PropsWithChildren, ReactNode } from "react";

interface CardHeaderProps extends PropsWithChildren {
  /** Optional element/s to include on the far right hand side of a card header*/
  headingRightContent?: ReactNode;
  /** Additional classes to add to the card header */
  extraHeaderClasses?: string;
  /** Any child element or elements. Generally a heading element or a paragraph tag with a heading class */
  children?: ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  headingRightContent,
  extraHeaderClasses,
  children,
}) => {
  const headerClasses = classNames("card__header", {
    "card__header--with-side-content": headingRightContent,
    [`${extraHeaderClasses}`]: extraHeaderClasses,
  });

  return (
    <header className={headerClasses}>
      {children}
      {headingRightContent && <>{headingRightContent}</>}
    </header>
  );
};
